import { render, staticRenderFns } from "./ComponentButtons.vue?vue&type=template&id=a92f0ad2&"
import script from "./ComponentButtons.vue?vue&type=script&lang=js&"
export * from "./ComponentButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports